module.exports = __webpack_public_path__ + "static/who-we-help-local-authorities-481896fd4221951946d5f0240bece313.jpg";